export const SET_FETCHING = 'template/SET_FETCHING';
export const SET_RESOLVER_DATA = 'template/SET_RESOLVER_DATA';
export const SET_REDIRECT = 'template/SET_REDIRECT';
export const SET_SHOULD_FETCH_DATA = 'template/SET_SHOULD_FETCH_DATA';
export const UPDATE_TEMPLATE_META = 'template/UPDATE_TEMPLATE_META';
export const RESET_STATE = 'template/RESET_STATE';
